// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(menu) {
  if (menu) {
    return "Show Dry Run";
  } else {
    return "Hide Dry Run";
  }
}

function fromString(menu) {
  if (menu === "Hide Dry Run") {
    return /* HideDryRun */0;
  } else {
    return /* ShowDryRun */1;
  }
}

export {
  toString ,
  fromString ,
  
}
/* No side effect */
